import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { classnames } from '@@client/lib/classes';
export default function HeaderSubHeaderBlueUnderlineAndSeparator(_ref) {
  var children = _ref.children,
      className = _ref.className,
      heading = _ref.heading,
      subHeading = _ref.subHeading;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-1336426471" + " " + (classnames(className, 'container') || ""),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "jsx-1336426471" + " " + 'heading',
        children: [/*#__PURE__*/_jsx("h1", {
          className: "jsx-1336426471",
          children: heading
        }), subHeading ? /*#__PURE__*/_jsx("div", {
          className: "jsx-1336426471" + " " + 'sub-heading',
          children: subHeading
        }) : null]
      }), children]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1336426471",
      children: [".container.jsx-1336426471{margin-bottom:15px;}", "@media(min-width:768px){.container.jsx-1336426471{padding-bottom:3px;border-bottom:2px solid #21409A;}}", "@media(min-width:768px){.heading.jsx-1336426471{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin-bottom:2px;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}}", ".heading.jsx-1336426471 h1.jsx-1336426471{margin:0;-webkit-box-flex:0;-ms-flex:0 0 190px;-webkit-flex:0 0 190px;-ms-flex:0 0 190px;flex:0 0 190px;}", ".sub-heading.jsx-1336426471{text-transform:uppercase;color:#21409A;}", "@media(min-width:768px){.sub-heading.jsx-1336426471{padding:5px 0 5px 23px;margin-left:25px;border-left:2px solid #21409A;font-weight:700;}}", "@media(min-width:768px) and (min-width:992px){.sub-heading.jsx-1336426471{margin-left:45px;}}"]
    })]
  });
}